import { defineStore } from "pinia";
import { ApiClient } from "@/api-client";
import { i18n } from "@/locales/index";
import { useSystemStore, useSupplierStore } from "./index";
import { watch } from "vue";
import { EventEmitter } from "events";

const apiClient = ApiClient.getInstance();

export const useMaterialStore = defineStore("materialStore", {
  state: () => ({
    selectedMatNr: "",
    selectedMatNrDescription: { de: "", en: "" },
    abortController: new AbortController(),
    loadingState: "initial" as loadingStateType | "initial",
    failedReason: "",
    onAbort: new EventEmitter(),
  }),
  actions: {
    async checkMaterial(material: string) {
      // get needed stores
      const systemStore = useSystemStore();
      const supplierStore = useSupplierStore();

      // clear matnr
      this.selectedMatNr = "";
      this.selectedMatNrDescription.de = "";
      this.selectedMatNrDescription.en = "";

      // check for user has made selections
      if (!systemStore.selectedSystem || !supplierStore.selectedSupplier)
        throw new Error("No system or supplier selected");

      //if  is still loading last request then abort it
      if (
        this.loadingState === "loading"
      ) {
        this.abortController.abort("Cancel Check for new Input");
        this.onAbort.emit("abort");
        return;
      }
      // set state
      this.loadingState = "loading";

      this.abortController = new AbortController();
      // check material
      let isValid;
      try {
        isValid = await apiClient.validateMaterial(
          material,
          supplierStore.selectedSupplier.SupplierId,
          systemStore.selectedSystem.supplierId,
          systemStore.selectedSystem.system,
          this.abortController.signal
        );
        if (!isValid) throw new Error("Invalid");
      } catch (error) {
        // just exit on abort error
        if (error instanceof Error && error?.name == "AbortError") return;

        // handle error
        this.loadingState = "failed";
        this.failedReason = i18n.global.t("app.material.loadingData.invalid", {
          material: material,
        });
        throw error;
      }

      // set data and state
      this.selectedMatNr = material;
      this.loadingState = "success";
    },
    initWatcher() {
      // clear material on supplier change
      watch(
        () => useSupplierStore().selectedSupplier,
        async (supplier) => {
          // skip initial set
          if (this.loadingState === "initial") return;
          this.loadingState = "unset";
        }
      );
    },
  },
});
